import { render, staticRenderFns } from "./PageTab.vue?vue&type=template&id=ae33a31c&scoped=true"
import script from "./PageTab.vue?vue&type=script&lang=js"
export * from "./PageTab.vue?vue&type=script&lang=js"
import style0 from "./PageTab.vue?vue&type=style&index=0&id=ae33a31c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae33a31c",
  null
  
)

export default component.exports